import { render, staticRenderFns } from "./vehicleFormBackup.vue?vue&type=template&id=b9a4176c"
import script from "./vehicleFormBackup.vue?vue&type=script&lang=js"
export * from "./vehicleFormBackup.vue?vue&type=script&lang=js"
import style0 from "./vehicleFormBackup.vue?vue&type=style&index=0&id=b9a4176c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports